import React, { useEffect, useState, useRef } from "react";
import { getWorkbookProperty, setWorkbookProperty } from "../../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";

const BackButtonDetector = () => {
  const dispatch = useDispatch();
  const name = useSelector((state) => getWorkbookProperty(state, "name"));
  const [editing, setEditing] = useState(false);
  const [workbookName, setWorkbookName] = useState(name);
  const inputRef = useRef(null);

  const handleBlur = () => {
    setEditing(false);
    dispatch(
      setWorkbookProperty({
        itemInArray: false,
        key: "name",
        value: workbookName,
      })
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleBlur();
    }
  };

  const handleNameChange = (e) => {
    setWorkbookName(e.target.value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        handleBlur();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [workbookName]); // Depend on workbookName to always have the latest value

  return (
    <div className="flex items-center justify-center gap-2 w-full sm:hidden md:flex font-[400]">
      {editing ? (
        <input
          ref={inputRef}
          className="font-[400]border-b border-white ml-2 px-1 min-w-56 w-28 h-7 truncate text-center outline-none focus:ring-0 bg-blue-950 text-white"
          value={workbookName}
          onChange={handleNameChange}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      ) : (
        <button
          className="text-[18px] relative left-0 font-[400]"
          onDoubleClick={() => setEditing(true)}
          onClick={() => setEditing(true)}
        >
          {name}
        </button>
      )}
    </div>
  );
};

export default BackButtonDetector;
